import FilterListIcon from "@mui/icons-material/FilterList";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import * as MUI from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useClinicListParams from "../hooks/useClinicListParams";
import { countActiveFilters } from "../utils/filterClinics";
import ClinicListFilters from "./ClinicListFilters";
import DebouncedTextField from "./DebouncedTextField";
import ImportClinicsDialog from "./ImportClinicsDialog";

export default function ClinicListToolbar({ onParsed }) {
  const { t } = useTranslation();
  const { search, setSearch, filters } = useClinicListParams();
  const activeFilterCount = countActiveFilters(filters);
  const [showFilters, setShowFilters] = useState(activeFilterCount > 0);
  const [isImportOpen, setIsImportOpen] = useState(false);

  return (
    <>
      <MUI.Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        <MUI.Stack direction="row" spacing={1} alignItems="center">
          <DebouncedTextField
            size="small"
            label={t("Search") + "..."}
            value={search}
            onCommit={setSearch}
            sx={{ minWidth: { sm: 320 }, flex: { xs: 1, sm: "none" } }}
          />
          <MUI.Badge badgeContent={activeFilterCount} color="primary">
            <MUI.Button
              variant={showFilters ? "contained" : "outlined"}
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters((prev) => !prev)}
            >
              {t("Filter")}
            </MUI.Button>
          </MUI.Badge>
        </MUI.Stack>
        <MUI.Button
          variant="contained"
          startIcon={<UploadFileIcon />}
          onClick={() => setIsImportOpen(true)}
        >
          {t("ImportClinics")}
        </MUI.Button>
      </MUI.Stack>

      {showFilters && <ClinicListFilters />}

      <ImportClinicsDialog
        open={isImportOpen}
        onClose={() => setIsImportOpen(false)}
        onParsed={onParsed}
      />
    </>
  );
}
